import { ViewModel,View } from "binder"
import { IStaticValueProvider } from "../IStaticValueProvider";
import  { ContentEditorView } from "./contentEditor-view"

export class ContentEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    
    GetDefaultView(): View <ViewModel> {
        return new ContentEditorView();
    }
    public getTypeId(): string {
        return "VM-4ECFB1DE-5B8A-4B0C-98B0-5E9D7D8ACCFB"
    }

    setValue(v: string) {
    }
    getValue(): string {
        return null;
    }

    requestConfirm() {
    }

}
